// ABM de accesos admin (página Access): quién puede loguearse a webadmin2 y si
// enroló el 2FA. Backend: MfaFn /mfa/admins (exige el JWT propio mfa:true).
const API_BASE =
  (import.meta.env.VITE_API_BASE as string | undefined) ??
  "http://localhost:3000";

export interface AdminRow {
  email:         string;
  allowed:       boolean;
  source:        "abm" | "config" | "-";  // abm = tabla; config = bootstrap del template
  enrolled:      boolean;                 // TOTP confirmado
  enrolled_at?:  string | null;
  confirmed_at?: string | null;
}

function authHeader(): Record<string, string> {
  const jwt = localStorage.getItem("webadmin2.jwt");
  return jwt ? { Authorization: `Bearer ${jwt}` } : {};
}

async function authFetch(url: string, init: RequestInit = {}): Promise<Response> {
  const res = await fetch(url, init);
  if (res.status === 401) {
    localStorage.removeItem("webadmin2.jwt");
    localStorage.removeItem("webadmin2.email");
    if (typeof window !== "undefined") window.location.replace("/login");
  }
  return res;
}

export interface AdminsList {
  items:    AdminRow[];
  domain:   string;
  canGrant: boolean;   // el usuario logueado puede habilitar personas (granter)
  granters: string[];  // quiénes pueden (para el texto de ayuda)
}

export async function listAdmins(): Promise<AdminsList> {
  const res = await authFetch(`${API_BASE}/mfa/admins`, { headers: authHeader() });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error ?? `listAdmins: ${res.status}`);
  return {
    items:    (data.items ?? []) as AdminRow[],
    domain:   String(data.domain ?? "cucuru.com"),
    canGrant: data.can_grant === true,
    granters: Array.isArray(data.granters) ? (data.granters as string[]) : [],
  };
}

export async function addAdmin(email: string): Promise<void> {
  const res = await authFetch(`${API_BASE}/mfa/admins`, {
    method:  "POST",
    headers: { "Content-Type": "application/json", ...authHeader() },
    body:    JSON.stringify({ email }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error ?? `addAdmin: ${res.status}`);
}

export async function removeAdmin(email: string): Promise<void> {
  const local = email.split("@", 1)[0] ?? email;
  const res = await authFetch(`${API_BASE}/mfa/admins/${encodeURIComponent(local)}`, {
    method:  "DELETE",
    headers: authHeader(),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error ?? `removeAdmin: ${res.status}`);
}
